<script setup lang="ts">
import NewsCard from '@/components/News/NewsCard.vue'

import type { SlugNews } from '@@/server/types/common'

const { $host } = useNuxtApp()

const route = useRoute()

const { data: news } = await useNuxtApi<SlugNews>(
  `/api/news/${route.params.slug}`,
)

const breadcrumbs = computed(() => {
  return [
    { text: 'Новости', href: 'news' },
    { text: news.value?.title || '', href: `news/${news.value?.slug}` },
  ]
})

const titleName = news.value?.title || 'Новости'
const title = `${titleName} - Farfor`
const description = `Больше новостей от Farfor - ${titleName}`

useHead({
  title,
  ...SEOMaker(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="news-page">
    <the-breadcrumbs
      class="news-page__breadcrumbs"
      theme="dark"
      :breadcrumbs="breadcrumbs"
      :domain="$host"
    />
    <news-card v-if="news" :news="news" is-full />
  </div>
</template>

<style lang="scss" scoped>
.news-page {
  padding: 45px 20px 0;

  &__breadcrumbs {
    margin-top: 39px;
    margin-bottom: 40px;
  }

  @include media($bp-tablet) {
    padding: 80px 48px 0;
  }

  @include media($bp-desktop-mini) {
    padding: 80px 0 120px 0; // 80 отступ сверху, 120 отступ снизу
  }
}
</style>
